export default __webpack_public_path__ + "static/media/back.c70cb287.svg";